import { CustomPage } from "../../DashboardApp/types";

// @ts-ignore
import Sku from "./pages/Sku";
import SortSku from "./pages/SortSku";

export const customPages = [
	{ moduleId: "66005204-3f56-488a-a3f0-514ed6ead337", path: "list", content: <Sku /> },
	{ moduleId: "66005204-3f56-488a-a3f0-514ed6ead337", path: "sort", content: <SortSku /> },
] as CustomPage[];
